"use client";

import React, { useState } from "react";
import { useRouter } from "next/navigation";
import MenuList from "@/components/Menu/MenuList";
import { MenuItem } from "@/components/Menu/menu.interface";
import { getMenuURL } from "@/components/Menu/helpers";
import styles from "./menu.module.scss";

interface RecursiveMenuProps {
  item: MenuItem;
  isHeadNav?: boolean;
}

const RecursiveMenu: React.FC<RecursiveMenuProps> = ({ item, isHeadNav }) => {
  const [accordionOpen, setAccordionOpen] = useState<boolean>(false);
  const { label, slug, type, children: childItems, iconURL } = item;

  const router = useRouter();

  const hasChildren: boolean = !!childItems?.length;

  const toggleAccordion: () => void = () => {
    setAccordionOpen((prev) => !prev);
  };

  const handleRoute: () => void = () => {
    router.push(getMenuURL(type, slug));
  };

  return (
    <>
      <MenuList
        titleIconUrl={iconURL}
        title={label}
        isHeadNav={isHeadNav}
        collapsible={hasChildren}
        isActive={accordionOpen}
        onClick={hasChildren ? toggleAccordion : handleRoute}
        ctaUrl={getMenuURL(type, slug)}
      />
      {hasChildren && (
        <div className={`${styles.subMenu} ${accordionOpen ? styles.open : ""}`}>
          <ul>
            {childItems.map((childItem: MenuItem, index) => {
              return (
                <li key={childItem?.slug}>
                  <RecursiveMenu item={childItem} />
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export default RecursiveMenu;
